import * as ActionTypes from '../ActionTypes'
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';

export const EmployerWorksitesReducer = (state = { 
                status: ReduxDataStatus.IDLE,
                loadTime: null,
                loadCriteria: {},
                errMess: null,
                worksites:[]
            }, action) => {
                
    switch (action.type) {
        case ActionTypes.EMPLOYER_WORKSITES_LOADING:
            return {...state, status: ReduxDataStatus.LOADING, errMess: null, worksites: [], loadTime: Date.now(), loadCriteria: action.payload }

        case ActionTypes.ADD_EMPLOYER_WORKSITES:
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, worksites: action.payload };

        case ActionTypes.EMPLOYER_WORKSITES_FAILED:
            return {...state, status: ReduxDataStatus.FAILED, errMess: action.payload, loadTime: null, loadCriteria: {} };

        case ActionTypes.ADD_EMPLOYER_WORKSITE:
            const nWorksite = action.payload;
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, worksites: state.worksites.concat(nWorksite) };

        case ActionTypes.UPDATE_EMPLOYER_WORKSITE:
            const uWorksite = action.payload;
            const updatedWLs = state.worksites.map(wl => wl.id === uWorksite.id ? uWorksite : wl );
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, worksites: updatedWLs};

        // case ActionTypes.DELETE_EMPLOYER_WORKSITE:
        //     const wlId = action.payload;
        //     const filteredWLs = state.worksites.filter(wl => wl.id !== wlId);
        //     return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, worksites: filteredWLs};

        default:
            return state;
    }
};